import React from "react";
import { Pressable, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import tw from "twrnc";
import Text from "@/components/shared/AppText";
import { t } from "@/localization";

// Shown on the event list while a nonprofit's fundraiser setup (from
// eventlive.pro/nonprofit) is unfinished.
const FundraiserSetupBanner = ({
  intent,
  event,
  onContinue,
  onDismiss,
  style,
}) => {
  if (!intent) return null;
  const orgName = intent.orgName || "";
  const eventCreated = intent.stage === "event_created" && !!event;

  const title = eventCreated
    ? t("Finish your fundraiser setup")
    : t("Set up your live fundraiser");
  const text = eventCreated
    ? orgName
      ? t(
          "Confirm {organization} and press Save to turn on donations for {event}.",
          { organization: orgName, event: event.title }
        )
      : t(
          "Confirm the organization and press Save to turn on donations for {event}.",
          { event: event.title }
        )
    : orgName
    ? t(
        "Schedule a live stream and collect donations for {organization} on your event page.",
        { organization: orgName }
      )
    : t("Schedule a live stream and collect donations on your event page.");
  const cta = eventCreated
    ? t("Review fundraiser")
    : t("Create fundraiser event");

  return (
    <View
      style={[tw`p-4 rounded-xl border border-orange-200 bg-orange-50`, style]}
    >
      <View style={tw`flex-row items-start`}>
        <Ionicons
          name="heart"
          size={20}
          color="#c74733"
          style={tw`mr-2 mt-0.5`}
        />
        <View style={tw`flex-1`}>
          <Text style={tw`font-bold text-base`}>{title}</Text>
          <Text style={tw`text-gray-700 mt-1 leading-5`}>{text}</Text>
          <Pressable
            accessibilityRole="button"
            onPress={onContinue}
            style={tw`mt-2 self-start py-1`}
          >
            <Text style={tw`text-[#c74733] font-bold`}>{cta} →</Text>
          </Pressable>
        </View>
        <Pressable
          accessibilityRole="button"
          accessibilityLabel={t("Dismiss fundraiser setup")}
          onPress={onDismiss}
          hitSlop={10}
          style={tw`ml-2`}
        >
          <Ionicons name="close" size={20} color="#8E8E93" />
        </Pressable>
      </View>
    </View>
  );
};

export default FundraiserSetupBanner;
